import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PessoaTipoBadgeModule } from '../../../tipo/components/badge';
import { ClienteCarteiraCongelarModule } from '../../../../cliente-carteira/congelar';
import { ClienteCarteiraPreBaixarModule } from '../../../../cliente-carteira/prebaixar';
import { ClienteCarteiraBaixarModule } from '../../../../cliente-carteira/baixar';
import { CanalMidiaSocialPipeModule } from '../../../../common/canal-midia-social/pipes/canal-midia-social.pipe.module';
import { OrigemPipeModule } from '../../../../common/origens/pipes/origem.pipe.module';
import { RepresentantePipeSharedModule } from '../../../representante/pipes/representante-pipe-shared.module';
import { NegocioFormInsertModalModule } from '../../../../crm/negocio/form-insert/modal/negocio-form-insert-modal.module';
import { ClienteAnaliseFinanceiraConcluirModule } from '../../analise-financeira/concluir-modal';
import { ClienteAnaliseFinanceiraRevisarModule } from '../../analise-financeira/revisar-modal';
import { ClienteAnaliseFinanceiraStatusBadgeModule } from '../../analise-financeira/status/badge';
import { ClienteCadastroModule } from '../../cadastro/cliente-cadastro.module';
import { ClienteSituacaoModule } from '../../situacao/cliente-situacao.module';
import { NovoClienteListComponent } from './novo-cliente-list.component';

@NgModule({
  imports: [
    SharedModule,
    PessoaTipoBadgeModule,
    ClienteAnaliseFinanceiraConcluirModule,
    ClienteAnaliseFinanceiraRevisarModule,
    ClienteAnaliseFinanceiraStatusBadgeModule,
    ClienteCarteiraCongelarModule,
    ClienteCarteiraPreBaixarModule,
    ClienteCarteiraBaixarModule,
    NegocioFormInsertModalModule,
    ClienteCadastroModule,
    ClienteSituacaoModule,
    OrigemPipeModule,
    CanalMidiaSocialPipeModule,
    RepresentantePipeSharedModule
  ],
  declarations: [NovoClienteListComponent],
  exports: [NovoClienteListComponent]
})
export class NovoClienteListModule {}
